"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var FontAwesomeSet;
(function (FontAwesomeSet) {
    FontAwesomeSet["Light"] = "light";
    FontAwesomeSet["Brand"] = "brand";
})(FontAwesomeSet = exports.FontAwesomeSet || (exports.FontAwesomeSet = {}));
var FontAwesomeFlip;
(function (FontAwesomeFlip) {
    FontAwesomeFlip["Both"] = "both";
    FontAwesomeFlip["Horizontal"] = "horizontal";
    FontAwesomeFlip["Vertical"] = "vertical";
})(FontAwesomeFlip = exports.FontAwesomeFlip || (exports.FontAwesomeFlip = {}));
var FontAwesomeRotation;
(function (FontAwesomeRotation) {
    FontAwesomeRotation["Deg180"] = "180";
    FontAwesomeRotation["Deg270"] = "270";
    FontAwesomeRotation["Deg90"] = "90";
})(FontAwesomeRotation = exports.FontAwesomeRotation || (exports.FontAwesomeRotation = {}));
var FontAwesomeSize;
(function (FontAwesomeSize) {
    FontAwesomeSize["Large"] = "lg";
    FontAwesomeSize["X2"] = "2x";
    FontAwesomeSize["X3"] = "3x";
    FontAwesomeSize["X4"] = "4x";
    FontAwesomeSize["X5"] = "5x";
})(FontAwesomeSize = exports.FontAwesomeSize || (exports.FontAwesomeSize = {}));
/**
 * Render a span tag with font awesome content;
 * @param props {@link FontAwesomeProps}
 */
var FontAwesome = (function (_a) {
    var className = _a.className, name = _a.name, set = _a.set, fixedWidth = _a.fixedWidth, flip = _a.flip, pulse = _a.pulse, rotate = _a.rotate, size = _a.size, spin = _a.spin, restProps = __rest(_a, ["className", "name", "set", "fixedWidth", "flip", "pulse", "rotate", "size", "spin"]);
    var _b;
    return (React.createElement("span", __assign({ "aria-hidden": true, className: classNames({
            fab: set === FontAwesomeSet.Brand,
            fal: !set || set === FontAwesomeSet.Light,
        }, "fa-" + name, (_b = {
                'fa-flip-horizontal': flip === FontAwesomeFlip.Horizontal ||
                    flip === FontAwesomeFlip.Both,
                'fa-flip-vertical': flip === FontAwesomeFlip.Vertical ||
                    flip === FontAwesomeFlip.Both,
                'fa-fw': fixedWidth,
                'fa-pulse': pulse,
                'fa-spin': spin
            },
            _b["fa-rotate-" + rotate] = rotate != null,
            _b["fa-" + size] = size != null,
            _b), className) }, restProps)));
});
exports.FontAwesome = FontAwesome;
FontAwesome.Set = FontAwesomeSet;
FontAwesome.Flip = FontAwesomeFlip;
FontAwesome.Rotation = FontAwesomeRotation;
FontAwesome.Size = FontAwesomeSize;
//# sourceMappingURL=FontAwesome.js.map